import { useContext } from "react";
import { usePrismicQuery } from "../../../hooks/usePrismicQuery";
import { PrismicLayoutContext } from "../context";
import { prismicLayoutQuery } from "../queries";
export function usePrismicLayoutQuery() {
  return usePrismicQuery(prismicLayoutQuery);
}
export var usePrismicLayout = function usePrismicLayout() {
  return useContext(PrismicLayoutContext);
};